import type { AppTextFieldProps } from "../form/constants";
import {
  TABLE_CELL_INPUT_SX,
  TABLE_ROW_GRID,
} from "../../assets/theme/custom/components/tableColumnsEditor";

/** Shared props for compact table-cell inputs (no outer margin, hidden label). */
export const tableCellFieldProps: Pick<
  AppTextFieldProps,
  "size" | "fullWidth" | "hiddenLabel" | "margin"
> = {
  size: "small",
  fullWidth: true,
  hiddenLabel: true,
  margin: "none",
};

/** Fixed height so Autocomplete, TextField and Select align in one row. */
export { TABLE_CELL_INPUT_SX, TABLE_ROW_GRID };
